import { LoaderCircle, X } from 'lucide-react'
import { useState } from 'react'

import { useEmpresa } from '../../context/EmpresaContext'
import { supabase } from '../../lib/supabase'

function ClienteRapidoPosModal({ onClose, onCreado }) {
  const { empresaActual } = useEmpresa()

  const [nombre, setNombre] = useState('')
  const [telefono, setTelefono] = useState('')
  const [guardando, setGuardando] = useState(false)
  const [error, setError] = useState('')

  const cerrar = () => {
    if (guardando) return
    onClose()
  }

  const crearCliente = async (event) => {
    event.preventDefault()

    if (guardando) return

    setError('')

    const nombreLimpio = nombre.trim()

    if (!nombreLimpio) {
      setError('Ingresa el nombre del cliente.')
      return
    }

    try {
      setGuardando(true)

      const { data, error: errorInsertar } = await supabase
        .from('clientes')
        .insert({
          empresa_id: empresaActual.id,
          razon_social: nombreLimpio,
          telefono: telefono.trim() || null,
          activo: true,
        })
        .select()
        .single()

      if (errorInsertar) {
        throw errorInsertar
      }

      onCreado?.(data)
    } catch (errorCreacion) {
      console.error('Error al crear cliente rápido:', errorCreacion)

      setError(
        errorCreacion.message || 'No fue posible crear el cliente.'
      )
    } finally {
      setGuardando(false)
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          cerrar()
        }
      }}
    >
      <div className="max-h-[90vh] w-full max-w-sm overflow-y-auto rounded-2xl bg-white p-5 shadow-xl sm:p-6">
        <div className="mb-5 flex items-start justify-between">
          <h2 className="text-lg font-bold text-slate-900">
            Nuevo cliente
          </h2>

          <button
            type="button"
            onClick={cerrar}
            disabled={guardando}
            aria-label="Cerrar"
            className="text-slate-400 transition hover:text-slate-600 disabled:cursor-not-allowed"
          >
            <X size={22} />
          </button>
        </div>

        <form
          className="space-y-4"
          onSubmit={crearCliente}
        >
          <div>
            <label
              htmlFor="cliente-rapido-nombre"
              className="mb-2 block text-sm font-semibold text-slate-700"
            >
              Nombre
              <span className="ml-1 text-red-500">*</span>
            </label>

            <input
              id="cliente-rapido-nombre"
              type="text"
              value={nombre}
              onChange={(event) => setNombre(event.target.value)}
              placeholder="Nombre del cliente"
              disabled={guardando}
              autoFocus
              className={estiloInput}
            />
          </div>

          <div>
            <label
              htmlFor="cliente-rapido-telefono"
              className="mb-2 block text-sm font-semibold text-slate-700"
            >
              Teléfono (opcional)
            </label>

            <input
              id="cliente-rapido-telefono"
              type="tel"
              inputMode="tel"
              value={telefono}
              onChange={(event) => setTelefono(event.target.value)}
              placeholder="+56 9 1234 5678"
              disabled={guardando}
              className={estiloInput}
            />
          </div>

          {error && (
            <div
              role="alert"
              className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
            >
              {error}
            </div>
          )}

          <div className="flex flex-col-reverse gap-3 pt-2">
            <button
              type="button"
              onClick={cerrar}
              disabled={guardando}
              className="w-full rounded-lg border border-slate-300 px-5 py-3 font-semibold text-slate-700 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60"
            >
              Cancelar
            </button>

            <button
              type="submit"
              disabled={guardando}
              className="flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-600 px-5 py-3 font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:bg-emerald-400"
            >
              {guardando && (
                <LoaderCircle
                  size={18}
                  className="animate-spin"
                />
              )}

              {guardando ? 'Creando...' : 'Crear cliente'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

const estiloInput =
  'w-full rounded-lg border border-slate-300 bg-white px-3 py-3 text-base outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100 disabled:bg-slate-100'

export default ClienteRapidoPosModal
